module.exports = __webpack_public_path__ + "img/Lender.8661cb23.png";